import React, { useState } from 'react';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';
const FAQS = [{
  question: '¿Esto es manipulación?',
  answer: 'No. Es aprender cómo funciona la atracción emocional real y mejorar tu seguridad. No se trata de engañar a nadie, sino de convertirte en tu mejor versión.'
}, {
  question: '¿Funciona si soy tímido?',
  answer: 'Sí. De hecho está pensado para personas que piensan demasiado o se bloquean. Te damos herramientas para gestionar esa ansiedad y usarla a tu favor.'
}, {
  question: '¿Necesito ser extrovertido?',
  answer: 'No. La atracción no depende de hablar mucho, sino de cómo te posicionas emocionalmente. El misterio y la escucha activa son armas poderosas.'
}, {
  question: '¿Y si ya me rechazaron mucho?',
  answer: 'Entonces este sistema es todavía más importante para ti. Aprenderás a resignificar el rechazo y a que no afecte tu autoestima.'
}, {
  question: '¿Cuánto tarda en verse resultado?',
  answer: 'Algunos cambios son inmediatos (mentalidad y comunicación). Otros se consolidan con práctica, pero notarás la diferencia en tu confianza desde el día 1.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 px-4 bg-slate-900 text-slate-100" data-id="element-58">
      <div className="max-w-3xl mx-auto" data-id="element-59">
        <div className="text-center mb-12" data-id="element-60">
          <HelpCircle className="w-12 h-12 text-[#FF6B35] mx-auto mb-4" data-id="element-61" />
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-62">
            Preguntas Frecuentes
          </h2>
          <p className="text-slate-400" data-id="element-63">
            Todo lo que necesitas saber antes de empezar
          </p>
        </div>

        <div className="space-y-4" data-id="element-64">
          {FAQS.map((faq, index) => <div key={index} className="border border-slate-700 rounded-lg bg-slate-800/50 overflow-hidden transition-all duration-200 hover:border-slate-600" data-id="element-65">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none" data-id="element-66">
                <span className="font-semibold text-lg pr-4" data-id="element-67">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-[#FF6B35] shrink-0" data-id="element-68" /> : <ChevronDown className="w-5 h-5 text-slate-400 shrink-0" data-id="element-69" />}
              </button>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-70">
                <div className="p-5 pt-0 text-slate-300 leading-relaxed border-t border-slate-700/50 mt-2" data-id="element-71">
                  {faq.answer}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}